export default __webpack_public_path__ + "static/media/times.012b7b75.ttf";